"use strict";
var _ = require("lodash");
var STUDENTS_PER_PAGE = 10;
var GROUP_INIT_DATA = "group";
var AVAILABLE_STUDENTS_INIT_DATA = "availableStudents";
var StudentStatus;
(function (StudentStatus) {
    StudentStatus[StudentStatus["active"] = 0] = "active";
    StudentStatus[StudentStatus["inactive"] = 1] = "inactive";
    StudentStatus[StudentStatus["all"] = 2] = "all";
})(StudentStatus || (StudentStatus = {}));
var DefaultGroupDetailController = (function () {
    /* @ngInject */
    function DefaultGroupDetailController($route, userService, $window, SUCCEED, groupsService, messagingService, userSessionService, FEATURE_TOGGLE) {
        var _this = this;
        this.$route = $route;
        this.$window = $window;
        this.groupsService = groupsService;
        this.messagingService = messagingService;
        this.userSessionService = userSessionService;
        this.FEATURE_TOGGLE = FEATURE_TOGGLE;
        this.currentPage = 1;
        this.showError = false;
        this.displayedStudentCount = 0;
        this.loadUser = function (currentUser) {
            _this.currentUser = currentUser;
            _this.updateCrumbs();
        };
        this.isAscendingSort = false;
        this.sortIcon = "ns-icon--sort";
        this.groupId = this.$route.current.params.groupId;
        this.tenantId = this.$route.current.params.tenantId;
        this.defaultGrades = this.$route.current.params.defaultGrades;
        userService.get().then(this.loadUser);
        this.messages = messagingService("students");
    }
    DefaultGroupDetailController.prototype.$onInit = function () {
        this.studentStatus = StudentStatus.all;
        this.group = this.$route.current.locals[GROUP_INIT_DATA];
        this.availableStudents = this.$route.current.locals[AVAILABLE_STUDENTS_INIT_DATA];
        if (this.availableStudents && this.availableStudents.length > 0) {
            this.sortStudents();
        }
        this.mapAvailableStudentStatuses();
        this.refreshDisplayedStudents();
        this.updateCrumbs();
    };
    DefaultGroupDetailController.prototype.hideError = function () { this.showError = false; };
    DefaultGroupDetailController.prototype.getDisplayInfo = function () {
        var count = this.currentPage * STUDENTS_PER_PAGE;
        var start = count - (STUDENTS_PER_PAGE - 1);
        var end = (count > this.getDisplayedStudentCount()) ? this.getDisplayedStudentCount() : count;
        return start + "-" + end;
    };
    DefaultGroupDetailController.prototype.isStudentStatusFilter = function (studentStatus) {
        return this.studentStatus === StudentStatus[studentStatus];
    };
    DefaultGroupDetailController.prototype.filterStudentsByStatus = function (status) {
        var studentStatus = StudentStatus[status];
        if (studentStatus === undefined) {
            this.showError = true;
        }
        else if (this.studentStatus !== studentStatus) {
            this.studentStatus = studentStatus;
            this.refreshDisplayedStudents();
        }
    };
    DefaultGroupDetailController.prototype.showPaginator = function () { return this.pages && this.pages.length > 1; };
    DefaultGroupDetailController.prototype.refreshDisplayedStudents = function () {
        var _this = this;
        this.pages = [[]];
        this.displayedStudentCount = 0;
        if (this.availableStudents) {
            this.availableStudents.forEach(function (student) {
                if (_this.isStatusMatch(student, _this.studentStatus)) {
                    var lastPage = _this.pages[_this.pages.length - 1];
                    if (lastPage.length >= STUDENTS_PER_PAGE) {
                        _this.pages.push([]);
                        lastPage = _this.pages[_this.pages.length - 1];
                    }
                    lastPage.push(student);
                    _this.displayedStudentCount++;
                }
            });
        }
        this.currentPage = Math.min(this.pages.length, this.currentPage);
    };
    DefaultGroupDetailController.prototype.isStatusMatch = function (student, studentStatus) {
        if (!student) {
            return false;
        }
        var match;
        switch (StudentStatus[studentStatus]) {
            case StudentStatus[StudentStatus.active]:
                match = student.active;
                break;
            case StudentStatus[StudentStatus.inactive]:
                match = !student.active;
                break;
            case StudentStatus[StudentStatus.all]:
                match = true;
                break;
            default:
                match = false;
        }
        return match;
    };
    DefaultGroupDetailController.prototype.getDisplayedStudentCount = function () {
        return this.displayedStudentCount;
    };
    DefaultGroupDetailController.prototype.getPageOfStudents = function () {
        return this.pages && this.pages[this.currentPage - 1];
    };
    DefaultGroupDetailController.prototype.hasDisplayedStudents = function () {
        return this.group && this.displayedStudentCount > 0;
    };
    DefaultGroupDetailController.prototype.sortStudents = function () {
        this.isAscendingSort = !this.isAscendingSort;
        this.sortByStudentName(this.isAscendingSort);
    };
    DefaultGroupDetailController.prototype.getMessage = function () {
        var key = "noStudentsForStatus";
        if (!this.availableStudents || this.availableStudents.length === 0) {
            key = "noStudents";
        }
        return this.messages[key];
    };
    DefaultGroupDetailController.prototype.updateCrumbs = function () {
        if (this.userSessionService.isDistrictMode()) {
            this.crumbs = [
                {
                    name: "Naviance Test Prep: District",
                    url: "" + this.userSessionService.getDistrictTenantId()
                },
                {
                    name: "" + this.userSessionService.getCurrentSchool().name,
                    url: "" + this.userSessionService.getDistrictTenantId()
                },
                { name: this.group.groupName }
            ];
        }
        else {
            this.crumbs = [
                {
                    name: "Naviance Test Prep",
                    url: "" + this.tenantId
                },
                { name: this.group.groupName }
            ];
        }
    };
    DefaultGroupDetailController.prototype.sortByStudentName = function (isAscending) {
        this.sortIcon = "ns-icon--sort-up";
        this.availableStudents = _.sortBy(this.availableStudents, ["lastName", "firstName"]);
        if (!isAscending) {
            this.sortIcon = "ns-icon--sort-down";
            this.availableStudents.reverse();
        }
        this.refreshDisplayedStudents();
    };
    DefaultGroupDetailController.prototype.mapAvailableStudentStatuses = function () {
        if (this.availableStudents && this.availableStudents.length > 0) {
            var activeStudentIds_1 = [];
            if (this.group.students) {
                activeStudentIds_1 = this.group.students.map(function (student) {
                    return student.userId;
                });
            }
            this.availableStudents.forEach(function (availableStudent) {
                availableStudent.active = activeStudentIds_1.indexOf(availableStudent.userId) >= 0;
            });
        }
    };
    return DefaultGroupDetailController;
}());
exports.DefaultGroupDetailController = DefaultGroupDetailController;



/** WEBPACK FOOTER **
 ** ./app/group-detail/default-group-detail.controller.ts
 **/